import angular from 'angular';
import uiRouter from 'angular-ui-router';

import './members.scss'
import memberDetailModule from './screens/member-detail';
import memberListModule from './screens/member-list';
import membersMapModule from './screens/members-map';

import MemberFactory from 'member.factory';
import memberCardComponent from 'member-card';

const membersModule = angular.module('members', [
  uiRouter,
  membersMapModule.name,
  memberListModule.name,
  memberDetailModule.name,
])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $stateProvider
      .state('engineer.members', {
        url: '/members',
        abstract: true,
        template: '<members ui-view class="members"></members>',
      });
  })
  .factory('Member', MemberFactory)
  .component('memberCard', memberCardComponent)
  .component('members', {});

export default membersModule;



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/members/index.js